// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/no-unknown-property */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { jsx } from 'theme-ui'
import ReviewsWidgetCircular from './ReviewsWidgetCircular'

const BoxStyled = styled.p`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  width: 132px;
  height: 132px;
  position: absolute;
  right: calc(100vw / 2 - 66px);
  display: block;
  overflow: visible;
  z-index: 6;
  bottom: -90px;
  width: 132px;
  height: 132px;
  @media (min-width: 30em) {
    display: block;
  }
  @media (min-width: 48em) {
    display: none;
  }
`

export const CutDownLeft = () => {
  return (
    <svg
      width="374"
      height="79"
      viewBox="0 0 374 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M70.5 78.5L374 0H0L70.5 78.5Z" fill="#8C8B8B" />
      <path d="M73.5 53L366.5 -12L0 -3.8147e-06L73.5 53Z" fill="white" />
    </svg>
  )
}

export const CutDownRight = () => (
  <svg width="374" height="68" viewBox="0 0 374 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M277.5 67.5L374 0H0L277.5 67.5Z" fill="#8C8B8B" />
    <path d="M268 42L364.5 -4.9422L0 0L268 42Z" fill="white" />
  </svg>
)

export const CutDownCenter = () => (
  <svg width="375" height="68" viewBox="0 0 375 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M185 68L374.5 0H0.5L185 68Z" fill="#8C8B8B" />
    <path d="M185 38L316 0H33L185 38Z" fill="white" />
  </svg>
)

export const RightAngle = ({ primary = 'primary', flip = false, ...props }) => {
  if (flip) {
    return (
      <svg
        preserveAspectRatio="none"
        sx={{
          '.sfill': {
            fill: primary,
          },
        }}
        viewBox="0 0 100 100"
        fill="none"
        {...props}
      >
        <polygon className="sfill" points="100,0 100,100 0,100" />
      </svg>
    )
  }

  return (
    <svg
      preserveAspectRatio="none"
      sx={{
        '.sfill': {
          fill: primary,
        },
      }}
      transform={flip ? 'scale(-1 1)' : null}
      viewBox="0 0 100 100"
      fill="none"
      {...props}
    >
      <polygon className="sfill" points="0,0 100,100 0,100" />
    </svg>
  )
}

export const CutUp = ({ primary = 'primary', secondary = 'background', ...props }) => (
  <svg
    preserveAspectRatio="none"
    sx={{
      '.sfill': {
        fill: primary,
      },
      '.sbg': {
        fill: secondary,
      },
    }}
    viewBox="0 0 374 59"
    fill="none"
    {...props}
  >
    <path className="sfill" d="M190.5.5l183 58.5H-.5L190.5.5z" fill="#8C8B8B" />
    <path className="sbg" d="M185.5 26l188 33H-.5l186-33z" fill="#fff" />
  </svg>
)

export const CutUpRight = () => (
  <svg width="374" height="89" viewBox="0 0 374 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M268.5 0L373.5 89H-0.5L268.5 0Z" fill="#8C8B8B" />
    <path d="M261 22.5L373.5 89H-0.5L261 22.5Z" fill="white" />
  </svg>
)

export const CutUpLeft = () => (
  <svg width="374" height="76" viewBox="0 0 374 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M132 0L373.5 76H-0.5L132 0Z" fill="#8C8B8B" />
    <path d="M140 20.5L342.5 76H27L140 20.5Z" fill="white" />
  </svg>
)

export const ReviewMobile = () => {
  const breakpoints = useBreakpoint()
  return (
    <BoxStyled>
      {breakpoints.md ? (
        <Link to="/testimonials">
          <ReviewsWidgetCircular />
        </Link>
      ) : null}
    </BoxStyled>
  )
}
